<div *ngIf="mobile">
  <ng-container *ngTemplateOutlet="zipCodeFilterContent"></ng-container>
</div>

<ng-container *ngIf="!mobile">
  <div
    class="filter-item"
    [matMenuTriggerFor]="zipCodeFilter"
    #trigger="matMenuTrigger"
    [ngClass]="{ active: isActive || isOpen }"
    (menuOpened)="isOpen = true"
    (menuClosed)="isOpen = false"
  >
    <span>Zip<span *ngIf="isActive && !!zipCode"> (1)</span></span>
    <app-shared-icon name="chevron-down-2"></app-shared-icon>
  </div>

  <mat-menu
    #zipCodeFilter="matMenu"
    xPosition="after"
    class="filters-mat-menu"
    (closed)="onMenuClose()"
  >
    <div
      class="filter-dropdown pt-2 px-4"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <ng-container *ngTemplateOutlet="zipCodeFilterContent"></ng-container>
      <app-filter-v2-buttons
        *ngIf="!mobile"
        (resetAction)="resetZipCode()"
        (applyAction)="closeMenu()"
      ></app-filter-v2-buttons>
    </div>
  </mat-menu>
</ng-container>

<ng-template #zipCodeFilterContent>
  <div class="filter-more-item">
    <label class="upper-label" for="zipCode">Zip code</label>

    <div class="inline-grid gap-x-3 grid-cols-1 w-full">
      <div class="label label-col2">
        <app-shared-input
          label="Digits"
          for="zipCode"
          [value]="zipCode || 'any'"
          [errors]="errors"
          [touched]="!!errors"
          patternError="Enter a valid zip code"
        >
          <input
            id="zipCode"
            name="zipCode"
            type="string"
            placeholder="Any"
            (input)="handleChange()"
            [(ngModel)]="zipCode"
            min="0"
            max="99999"
            (focus)="selectAll($event)"
            inputmode="numeric"
          />
        </app-shared-input>
      </div>
    </div>
  </div>
</ng-template>
